/* eslint semi: 1 */
import { defineStore } from 'pinia';

import { Dependencies } from '../../globals/utils';

let dataStoreInstance = null;

const TIMEFORMAT = {
  24: 'HH:mm',
  12: 'hh:mm A'
};

/**
 * $dataStore instance getter and injection instead of
 * relying to Vue.globalProperties we can use provided
 * dependency from main
 */
function getDataStoreInstance () {
  if (!dataStoreInstance) {
    dataStoreInstance = Dependencies.inject('$dataStore');

    if (!dataStoreInstance) {
      throw new Error('Unable to inject $dataStore dependency');
    }
  }

  return dataStoreInstance;
}

export const useGlobalStore = defineStore('global-store', {
  state: () => ({
    savedTimeFormat: ''
  }),
  getters: {
    preferredTimeFormat (state) {
      const timeFormat = state.savedTimeFormat || getDataStoreInstance().getPreferredTimeFormat();
      return timeFormat === '12' ? TIMEFORMAT[12] : TIMEFORMAT[24];
    }
  },
  actions: ({
    savePreferredTimeFormat (timePickerFormat) {
      const preferredTimeFormat = Object.keys(TIMEFORMAT).find((key) => TIMEFORMAT[key] === timePickerFormat);

      if (!preferredTimeFormat) return;

      this.savedTimeFormat = preferredTimeFormat;

      // Inject $dataStore dependency
      const $dataStore = getDataStoreInstance();
      $dataStore.setPreferredTimeFormat(preferredTimeFormat);
    }
  })
});
